module.exports = __webpack_public_path__ + "img/logo-cropped.0277dcc8.svg";